<template>
<div>
 <!-- <transition-group tag="ul" :name="transition"  class="blog__feed">-->
     <div id="contact-form" class="contact-form" key="id">
   <hr size=20 key="id0">
		<h1 class="contact-form_title"  key="id1">Contactez-nous : <a href="mailto::ccmartigny@gmail.com"><font color="blue">ccmartigny@gmail.com</font></A>
	</h1>
  <!--	<div class="separator" key="id2"></div>-->
	<!--	<div v-if="isSending" class="loading" key="id3">Envoi en cours...</div>-->
	<!--	<form class="form" @submit="onSubmit" key="id4">
			<input required name="name" v-model='contact.name' placeholder="Name" type="text" autocomplete="off" key="id4">
			<input required name="email" v-model="contact.email" placeholder="E-mail" type="email" autocomplete="off" key="id5">
			<textarea name="message" v-model="contact.message" rows="4" placeholder="Message" key="id6"></textarea>
		   <button class="button" key="id7">Envoyer</button>
		</form>
   --> 
	</div>
  <!--</transition-group>-->
</div>
</template>

<script>
import Vue from 'vue'
import { scrollTo } from '../helpers'
import VueResource from 'vue-resource'
Vue.use(VueResource)

export default {
  name: 'contactform',
  resource: 'BlogFeed',

  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      transition: 'preview-appear',
      contact: {
        name: '',
        email: '',
        message: ''
      },

      isSending: false
    }
  },

  methods: {
    scrollTo,
    clearForm() {
      for (let field in this.contact) {
        this.contact[field] = ''
      }
    },
    onSubmit(evt) {
      evt.preventDefault();

      this.isSending = true;

      setTimeout(() => {
        let form = new FormData();
        for (let field in this.contact) {
          form.append(field, this.contact[field]);
        }
        this.$http.post('./static/email.php', form).then((response) => {
          this.clearForm();
          this.isSending = false;
        }).catch((e) => {
          console.log(e)
        });
      }, 1000);
    }

  }
}
</script>
<style>
body {
	background: #f1f1f1;
	font-family: 'Roboto', sans-serif;
}

.contact-form {
	font-family: 16px;
	margin: 0 auto;
	max-width: 600px;
	width: 100%;
}

.contact-form .separator {
	border-bottom: solid 1px #ccc;
	margin-bottom: 15px;
}

.contact-form .form {
	display: flex;
	flex-direction: column;
	font-size: 16px;
}

.contact-form_title {
	color: #333;
	text-align: left;
	font-size: 28px;
}

.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form textarea {
	border: solid 1px #e8e8e8;
	font-family: 'Roboto', sans-serif;
	padding: 10px 7px;
	margin-bottom: 15px;
	outline: none;
}

.contact-form textarea {
	resize: none;
}

.contact-form .button {
	background: #da552f;
	border: solid 1px #da552f;
	color: white;
	cursor: pointer;
	padding: 10px 50px;
	text-align: center;
	text-transform: uppercase;
}

.contact-form .button:hover {
	background: #ea532a;
	border: solid 1px #ea532a;
}

.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form textarea,
.contact-form .button {
	font-size: 15px;
	border-radius: 3px
}
</style>


// WEBPACK FOOTER //
// src/components/ContactForm.vue